import React, {useRef} from 'react'
import AudioPlayer from '../components/AudioPlayer'
import AdjustingImage from '../components/AdjustingImage'


function AstPencilcase({containerSize}) {
	const headerRef = useRef()
	const footerRef = useRef()

	return(
		<div className="panel-body">
			<section className="asset-header" ref={headerRef}>
				<h1>No school things on the floor!</h1>
			</section>
			<section className="asset-content">
				<AdjustingImage src="./assets/images/vi07864010_360tour_pencilcase.jpg" alt="Ein Mäppchen liegt auf dem Fußboden"
					headerRef={headerRef}
					footerRef={footerRef}
					containerSize={containerSize}
					hasAudioPlayer={true}
				/>
				<AudioPlayer url="./assets/audio/au25864010_Track_003.mp3" />
			</section>
			<section className="asset-footer" ref={footerRef}>
				<p className="reference">Bildquelle: Fosseway Films Ltd. (Jesùs Santaeularia)<br/>
				Audioquellen: Tonmeister: Joschi Kauffmann, Stuttgart; Tonstudio: jkstudio GmbH, Stuttgart; Sprecher: Mark Borrill
				</p>
			</section>
		</div>
	)
}

export default AstPencilcase
